import $ from 'jquery';
import MovieSet from './MovieSet';

export default class MovieController {

    constructor() {

        let _this = this;
        this.$modal = $("#prg-player-modal");
        this.initYTP();

        $('.prg-movie-set').each(function(){
            let _$set = $(this);
            let mset = new MovieSet(_$set, _$set.data('movieid'), _this);
        });

        $('#prg-modal-close, #prg-modal-bg').on('click', () => {
            _this.stopMovie();
        })

    }

    initYTP() {
        let _this = this;

        // IFrame Player API の読み込み
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubePlayerAPIReady = () => {
            _this.YT_PLAYER = new YT.Player('player', {
                width: '100%',
                height: '100%',
                movieId: '',
                // パラメータの設定
                playerVars: {
                    rel: 0, // 再生終了後に関連動画を表示するかどうか設定,
                    'origin': location.protocol + '//' + location.hostname + '/'
                }
            });
        };
    }

    playMovie(movieId) {
        this.$modal.addClass('is-active');
        if (this.YT_PLAYER) {
            this.YT_PLAYER.loadVideoById(movieId, 0, 'default');
        }
    }

    stopMovie() {
        this.$modal.removeClass('is-active');
        this.YT_PLAYER.pauseVideo();
    }

}



// WEBPACK FOOTER //
// ./src/scripts/MovieController.js